/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HistoricalDataPoint } from "./HistoricalDataPoint.ts";

export const historicalWalletsResponseNetworkEnum = {
	REGTEST: "REGTEST",
	MAINNET: "MAINNET",
} as const;

export type HistoricalWalletsResponseNetworkEnum =
	(typeof historicalWalletsResponseNetworkEnum)[keyof typeof historicalWalletsResponseNetworkEnum];

export const historicalWalletsResponseGranularityEnum = {
	daily: "daily",
	weekly: "weekly",
} as const;

export type HistoricalWalletsResponseGranularityEnum =
	(typeof historicalWalletsResponseGranularityEnum)[keyof typeof historicalWalletsResponseGranularityEnum];

export type HistoricalWalletsResponse = {
	/**
	 * @type string
	 */
	network: HistoricalWalletsResponseNetworkEnum;
	/**
	 * @type string, date
	 */
	start_date: string;
	/**
	 * @type string, date
	 */
	end_date: string;
	/**
	 * @type string
	 */
	granularity: HistoricalWalletsResponseGranularityEnum;
	/**
	 * @type array
	 */
	data: HistoricalDataPoint[];
};
